export const HOW_TO_HOST_LINK = 'https://inclusivv.co/how-to-host/'
